import { useEffect, useState } from "react";
import PageLayout from "./components/PageLayout";
import MerchProductCard from "./components/merch/MerchProductCard";
import { MerchResponsiveStyles, sectionLabelStyle } from "./components/merch/MerchStyles";
import { getMerchCollectionById } from "./data/merchCollections";
import { getMerchProducts } from "./services/merchProducts";

function MerchCollection() {
  const collection = getMerchCollectionById("identity");
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    getMerchProducts({ publishedOnly: true })
      .then((items) => setProducts(collection.productIds
        .map((productId) => items.find(
          (product) => product.id === productId && product.collectionId === collection.id
        ))
        .filter(Boolean)))
      .catch((loadError) => setError(loadError.message || "Products could not be loaded."))
      .finally(() => setLoading(false));
  }, [collection.id, collection.productIds]);

  return (
    <PageLayout maxWidth="1100px" showBack eyebrow={collection.number} title={collection.title} subtitle={collection.subtitle}>
      <MerchResponsiveStyles />
      <section style={{ maxWidth: "720px", margin: "clamp(48px, 7vw, 80px) 0 clamp(38px, 6vw, 62px)", borderLeft: "3px solid #e10600", paddingLeft: "clamp(20px, 3vw, 32px)" }} aria-label="Collection statement">
        <p style={sectionLabelStyle}>The {collection.title} Collection</p>
        <h2 style={{ margin: "0 0 16px", fontSize: "clamp(27px, 4vw, 42px)", lineHeight: 1.12, letterSpacing: "-0.03em" }}>{collection.manifesto}</h2>
        <p style={{ maxWidth: "650px", margin: 0, color: "#999", fontSize: "16px", lineHeight: 1.7 }}>{collection.description}</p>
      </section>
      <section className="merch-product-grid" aria-label="Identity collection products">
        {loading && <p style={{ color: "#999" }}>Loading products…</p>}
        {error && <p role="alert" style={{ color: "#ff8b87" }}>{error}</p>}
        {!loading && !error && products.map((product) => <MerchProductCard key={product.id} product={product} />)}
        {!loading && !error && products.length === 0 && <p style={{ color: "#999" }}>No published products are available.</p>}
      </section>
    </PageLayout>
  );
}

export default MerchCollection;
